import { render, staticRenderFns } from "./gongyu.vue?vue&type=template&id=18c856ef&scoped=true&"
import script from "./gongyu.vue?vue&type=script&lang=js&"
export * from "./gongyu.vue?vue&type=script&lang=js&"
import style0 from "./gongyu.vue?vue&type=style&index=0&id=18c856ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c856ef",
  null
  
)

export default component.exports